import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const AddFoto = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const handleCancel = () => {
    navigate("/admin/foto");
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) {
      return;
    }

    setLoadingUpload(true);

    try {
      const uploadedUrls = [];

      for (const file of files) {
        const formData = new FormData();

        formData.append("file", file);

        const response = await axios.post(
          "/api_w/upload/multiple",
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              db_name: process.env.REACT_APP_DB_NAME,
            },
          }
        );

        console.log("Response Upload:", response.data);

        const uploadedData = response.data?.data;

        if (!uploadedData || uploadedData.length === 0) {
          throw new Error("URL gambar tidak ditemukan dari response upload");
        }

        const uploadedImageUrl =
          uploadedData[0]?.Location ||
          uploadedData[0]?.location ||
          uploadedData[0]?.url;

        if (!uploadedImageUrl) {
          throw new Error("URL gambar hasil upload tidak ditemukan");
        }

        uploadedUrls.push(uploadedImageUrl);
      }

      setImageUrls(uploadedUrls);

      toast.success("Berhasil upload gambar!");
    } catch (error) {
      console.error("Error Upload Gambar:", error.response?.data || error);

      toast.error(
        "Error Upload Gambar: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleSubmit = async () => {
    if (!title.trim()) {
      toast.error("Judul foto wajib diisi!");
      return;
    }

    if (imageUrls.length === 0) {
      toast.error("Silakan upload gambar terlebih dahulu!");
      return;
    }

    setLoadingSubmit(true);

    try {
      /**
       * Jika kolom url pada database bertipe STRING/VARCHAR,
       * maka array URL harus diubah menjadi string.
       *
       * Contoh:
       * [
       *   "url-gambar-1",
       *   "url-gambar-2"
       * ]
       *
       * Menjadi:
       * "url-gambar-1,url-gambar-2"
       */
      const galleryData = {
        title: title.trim(),
        url: imageUrls.join(","),
        type: "image",
      };

      console.log("Data yang dikirim ke API Gallery:", galleryData);

      const response = await axios.post(
        "/api_w/galleries",
        galleryData,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
            db_name: process.env.REACT_APP_DB_NAME,
          },
        }
      );

      console.log("Response Gallery:", response.data);

      toast.success("Berhasil Tambah Foto!");

      navigate("/admin/foto");
    } catch (error) {
      console.error(
        "Error Tambah Foto:",
        error.response?.data || error
      );

      toast.error(
        "Error Tambah Foto: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <div className="p-5">
      {/* TITLE */}
      <div className="mb-4">
        <label className="text-md mb-2 block font-bold text-gray-800 dark:text-white">
          Judul
        </label>

        <input
          type="text"
          id="title"
          name="title"
          className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
          placeholder="Judul"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      {/* IMAGE */}
      <div className="mb-4">
        <label className="text-md block font-bold text-gray-800 dark:text-white">
          Gambar
        </label>

        {imageUrls.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-4 dark:text-white">
            {imageUrls.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Foto ${index + 1}`}
                className="h-24 w-24 rounded-md object-cover"
              />
            ))}
          </div>
        )}

        <input
          type="file"
          id="img"
          name="img"
          accept="image/png,image/jpg,image/jpeg,image/svg+xml,image/webp"
          multiple
          disabled={loadingUpload}
          className="w-full rounded border px-3 py-2 dark:text-white"
          onChange={handleFileChange}
        />

        <span className="ml-1 mt-0 block text-xs text-gray-600">
          *Max size: 5MB, Format: .png, .jpg, .jpeg, .svg, .webp
        </span>

        {loadingUpload && (
          <p className="mt-2 text-sm text-blue-600">
            Sedang upload gambar...
          </p>
        )}
      </div>

      {/* BUTTON */}
      <div className="flex justify-end gap-4">
        <button
          type="button"
          className="rounded bg-red-500 px-4 py-2 font-bold text-white"
          onClick={handleCancel}
          disabled={loadingSubmit || loadingUpload}
        >
          Batal
        </button>

        <button
          type="button"
          className="rounded bg-green-600 px-4 py-2 font-bold text-white disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleSubmit}
          disabled={loadingSubmit || loadingUpload}
        >
          {loadingSubmit ? "Menyimpan..." : "Tambah"}
        </button>
      </div>
    </div>
  );
};

export default AddFoto;

